
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8ys6G", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $63a74d272ad07654$export$6503ec6e8aabbaf; }, function (v) { return $63a74d272ad07654$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $63a74d272ad07654$export$f7ad0328861e2f03; }, function (v) { return $63a74d272ad07654$export$f7ad0328861e2f03 = v; });
var $63a74d272ad07654$export$6503ec6e8aabbaf;
var $63a74d272ad07654$export$f7ad0328861e2f03;
"use strict";
var $63a74d272ad07654$var$mapping = new Map();
function $63a74d272ad07654$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$63a74d272ad07654$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $63a74d272ad07654$var$resolve(id) {
    var resolved = $63a74d272ad07654$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$63a74d272ad07654$export$6503ec6e8aabbaf = $63a74d272ad07654$var$register;
$63a74d272ad07654$export$f7ad0328861e2f03 = $63a74d272ad07654$var$resolve;

});

parcelRegister("jNZCW", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e6b265ccda22670e$export$bdfd709ae4826697; }, function (v) { return $e6b265ccda22670e$export$bdfd709ae4826697 = v; });
var $e6b265ccda22670e$export$bdfd709ae4826697;
var $e6b265ccda22670e$export$c9e73fbda7da57b6;
var $e6b265ccda22670e$export$5a759dc7a1cfb72a;
"use strict";
var $e6b265ccda22670e$var$bundleURL = {};
function $e6b265ccda22670e$var$getBundleURLCached(id) {
    var value = $e6b265ccda22670e$var$bundleURL[id];
    if (!value) {
        value = $e6b265ccda22670e$var$getBundleURL();
        $e6b265ccda22670e$var$bundleURL[id] = value;
    }
    return value;
}
function $e6b265ccda22670e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e6b265ccda22670e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e6b265ccda22670e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e6b265ccda22670e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e6b265ccda22670e$export$bdfd709ae4826697 = $e6b265ccda22670e$var$getBundleURLCached;
$e6b265ccda22670e$export$c9e73fbda7da57b6 = $e6b265ccda22670e$var$getBaseURL;
$e6b265ccda22670e$export$5a759dc7a1cfb72a = $e6b265ccda22670e$var$getOrigin;

});

parcelRegister("7X67o", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("bsivy")).then(()=>parcelRequire("a3T36"));

});
parcelRegister("fdh9B", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("86uf3", function(module, exports) {
"use strict";
var $5e6657a4c050a44a$var$cachedBundles = {};
var $5e6657a4c050a44a$var$cachedPreloads = {};
var $5e6657a4c050a44a$var$cachedPrefetches = {};
function $5e6657a4c050a44a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5e6657a4c050a44a$var$cachedPreloads;
        case "prefetch":
            return $5e6657a4c050a44a$var$cachedPrefetches;
        default:
            return $5e6657a4c050a44a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5e6657a4c050a44a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("Z1fyG", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("6Z0ku")).then(()=>parcelRequire("22wE9"));

});

parcelRegister("gx6Cy", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("43AsH")).then(()=>parcelRequire("4xjZU"));

});

parcelRegister("2Evrk", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("ednZ3")).then(()=>parcelRequire("gTZWG"));

});

parcelRegister("6HUho", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("jsjRj")).then(()=>parcelRequire("2p3V6"));

});

parcelRegister("hPMxO", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("rgu5s")).then(()=>parcelRequire("66HqG"));

});

parcelRegister("EdbR8", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("jhZeA")).then(()=>parcelRequire("lLcGC"));

});

parcelRegister("bW1Mx", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("c1BDh")).then(()=>parcelRequire("izefo"));

});

parcelRegister("DmlwE", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("aLQMU")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("2jEVT")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("kh6Xy"))
]).then(()=>parcelRequire("dPWFN"));

});
parcelRegister("kRdHQ", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRegister("fJCLE", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("aLQMU")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("2jEVT")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("abFYT"))
]).then(()=>parcelRequire("8zAsu"));

});

parcelRegister("aR8XW", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("aLQMU")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("2jEVT")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("7JYiH"))
]).then(()=>parcelRequire("e1oeP"));

});

parcelRegister("63MTf", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("aLQMU")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("2jEVT")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("gpyuX"))
]).then(()=>parcelRequire("m4HOl"));

});

parcelRegister("fgxBm", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("aibmu")).then(()=>parcelRequire("i7dd3"));

});

parcelRegister("4fr5w", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("eKe2N")).then(()=>parcelRequire("kvhFa"));

});

parcelRegister("gAuJW", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("7sfoH")).then(()=>parcelRequire("2aTQQ"));

});

parcelRegister("55eOb", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("lEHHo")).then(()=>parcelRequire("93hQP"));

});

parcelRegister("3gWmr", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("acSUJ")).then(()=>parcelRequire("f2NoN"));

});

var $d34568567572131e$exports = {};


(parcelRequire("8ys6G")).register((parcelRequire("jNZCW")).getBundleURL("2NZQs"), JSON.parse('["2NZQs","as-modern.js","bsivy","eyeAble.6761498f.js","6Z0ku","ccm19.780f34fb.js","43AsH","dialogHandler.13baf9c2.js","ednZ3","mainMenu.dd1ac889.js","jsjRj","languageSelect.53cfa579.js","rgu5s","submenu.812d9f9d.js","jhZeA","accordion.8fa9b985.js","c1BDh","defaultAccordion.8ddf0ae6.js","kh6Xy","swiper.13346757.js","2jEVT","swiper.20a1705b.js","aLQMU","swiper.787bb8d1.css","abFYT","certificateSwiper.cebe1bcd.js","7JYiH","homeSwiper.569edad8.js","gpyuX","imageSwiper.d506c465.js","aibmu","popoverSelect.c1ac8688.js","eKe2N","asAddressSearch.ddd1c73e.js","7sfoH","asBodyCompass.e8a14fd2.js","lEHHo","eventCardClickHandler.7acb5c0b.js","acSUJ","sfEventMgt.fb41ac68.js"]'));

// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
const $c650d1302b554f6f$export$d680cb6eec13a7c7 = ()=>new Promise((resolve)=>{
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
const $c650d1302b554f6f$export$be1257a3a9248b22 = ()=>new Promise((resolve)=>{
        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
            timeout: 1000
        });
        else setTimeout(resolve, 100);
    });


// =========================================================================
// CRITICAL: Cache selectors + load immediately (blocking)
// =========================================================================
const $d24485f84e15129c$var$contrastTrigger = document.querySelector(".btn--contrast");
const $d24485f84e15129c$var$hasCCM = document.querySelector("[data-ccm-loader-group]");
const $d24485f84e15129c$var$criticalImports = [];

if ($d24485f84e15129c$var$contrastTrigger) $d24485f84e15129c$var$criticalImports.push((parcelRequire("7X67o")).then((m)=>m.init()));

if ($d24485f84e15129c$var$hasCCM) $d24485f84e15129c$var$criticalImports.push((parcelRequire("Z1fyG")).then((m)=>m.init()));
if ($d24485f84e15129c$var$criticalImports.length) Promise.all($d24485f84e15129c$var$criticalImports).catch(console.error);







// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
(0, $c650d1302b554f6f$export$d680cb6eec13a7c7)().then(()=>{
    // Cache selectors
    const searchDialog = document.querySelector("#search-modal-dialog") || document.querySelector(".header-search-modal") || document.querySelector('[data-js="header-search"]');
    const burger = document.querySelector("#burger-modal-dialog") || document.querySelector(".burger-menu-modal") || document.querySelector('[data-js="burger-menu"]');
    const languageSelect = document.querySelector(".language-select-trigger");
    const submenuTrigger = document.querySelector(".open-submenu-button");
    const accordionTrigger = document.querySelector(".burger-menu__link-button") || document.querySelector("[data-js='as-accordion-details-item']");
    const defaultAccordionTrigger = document.querySelector("[data-js='accordion-item']");
    const mainMenu = document.querySelector(".main-menu--primary");
    const imports = [];
    if (searchDialog) imports.push((parcelRequire("gx6Cy")).then((m)=>m.init("#search-modal-dialog", ".header-search-modal", '[data-js="header-search"]', '[data-js="header-search-modal-close"]', '[name="tx_solr[q]"]')));
    if (burger) imports.push((parcelRequire("gx6Cy")).then((m)=>m.init("#burger-modal-dialog", ".burger-menu-modal", ".btn--burger-2", '[data-js="burger-menu-modal-close"]')));
    if (mainMenu) imports.push((parcelRequire("2Evrk")).then((m)=>m.init()));
    if (languageSelect) imports.push((parcelRequire("6HUho")).then((m)=>m.init()));
    if (submenuTrigger) imports.push((parcelRequire("hPMxO")).then((m)=>m.init(".open-submenu-button")));
    if (accordionTrigger) imports.push((parcelRequire("EdbR8")).then((m)=>m.init()));
    if (defaultAccordionTrigger) imports.push((parcelRequire("bW1Mx")).then((m)=>m.init()));
    if (imports.length) Promise.all(imports).catch(console.error);
});









// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
(0, $c650d1302b554f6f$export$be1257a3a9248b22)().then(()=>{
    // Cache selectors
    const swiper = document.querySelector(".swiper-container");
    const certificateSwiper = document.querySelector(".certificate-swiper-container");
    const homeSwiper = document.querySelector(".home-swiper-container");
    const imageSwiper = document.querySelector(".image-swiper-container");
    const popoverSelect = document.querySelector('[data-component*="popover-select-trigger"]');
    const doctorFinder = document.querySelector(".doctor-finder.tx-as-address-search");
    const bodyCompass = document.querySelector(".ctype-ce_body_compass");
    const eventList = document.querySelector(".tx-sf-event-mgt");
    const eventSearchForm = document.getElementById("searchDemand");
    const imports = [];
    if (swiper) imports.push((parcelRequire("DmlwE")).then((m)=>m.init()));
    if (certificateSwiper) imports.push((parcelRequire("fJCLE")).then((m)=>m.init()));
    if (homeSwiper) imports.push((parcelRequire("aR8XW")).then((m)=>m.init()));
    if (imageSwiper) imports.push((parcelRequire("63MTf")).then((m)=>m.init()));
    if (popoverSelect) imports.push((parcelRequire("fgxBm")).then((m)=>m.init()));
    if (doctorFinder) imports.push((parcelRequire("4fr5w")).then((m)=>m.init()));
    if (bodyCompass) imports.push((parcelRequire("gAuJW")).then((m)=>m.init()));
    if (eventList) imports.push((parcelRequire("55eOb")).then((m)=>m.init()));
    if (eventSearchForm) imports.push((parcelRequire("3gWmr")).then((m)=>m.init()));
    if (imports.length) Promise.all(imports).catch(console.error);
});


//# sourceMappingURL=as-modern.js.map
